import { render } from "./TicketCreate.vue?vue&type=template&id=296df238&scoped=true"
import script from "./TicketCreate.vue?vue&type=script&lang=js"
export * from "./TicketCreate.vue?vue&type=script&lang=js"

import "./TicketCreate.vue?vue&type=style&index=0&id=296df238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296df238"]])

export default __exports__